module.exports = __webpack_public_path__ + "static/lineto-circular-black-dc82098506ee5b63c5eb45b267d16b69.woff";